import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import useLeadMutations from "./useLeadMutations";
import { ISingleLeadRespose } from "../models/Lead";
import apiConfig from "../utils/apiConfig";

export default function useSingleLead(
  leadId: string,
  componentName = "useSingleLead"
) {
  const { get } = useApiHelper(apiConfig(componentName));
  const mutations = useLeadMutations(leadId, componentName);
  const enabled = Boolean(leadId);

  const lead = useQuery({
    queryKey: ["lead", leadId],
    queryFn: () => get<ISingleLeadRespose>(`/lead/${leadId}`),
    staleTime: 1000 * 60 * 10, // 10 minutes
    enabled,
  });

  return {
    ...mutations,
    lead,
  };
}
